import React from 'react';
import '../styles/RatioDetailModal.css';
import ReactMarkdown from 'react-markdown';

const RatioDetailModal = ({ isOpen, ratio, onClose }) => {
    if (!isOpen || !ratio) return null;

    return (
        <div className="ratio-modal-overlay">
            <div className="ratio-modal">
                <h3>{ratio.displayName}</h3>
                <p><strong>Description:</strong></p>
                <ReactMarkdown children={ratio.description} />
                <p><strong>Formula:</strong> <code>{ratio.formula}</code></p>
                <button onClick={onClose}>Close</button>
            </div>
        </div>
    );
};

export default RatioDetailModal;
